import { ErrorMessage, Field } from 'formik';
import { Col, Form, FormControl, Row } from 'react-bootstrap';
import { FormLabel, FormStepHeader } from '../../../components/forms';
import { StepProps } from '../Register';

export const BasicInfoForm = ({ touched, errors }: StepProps) => {
  return (
    <>
      <FormStepHeader title="Basic Info" />

      <Row>
        <Col
          xs={6}
          className="pe-1"
        >
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="first_name"
          >
            <FormLabel required>First Name</FormLabel>
            <Field
              name="first_name"
              type="text"
              as={Form.Control}
              isInvalid={touched.first_name && !!errors.first_name}
              aria-required
            />
            <ErrorMessage name="first_name">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>
        </Col>
        <Col
          xs={6}
          className="ps-1"
        >
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="last_name"
          >
            <FormLabel required>Last Name</FormLabel>
            <Field
              name="last_name"
              type="text"
              as={Form.Control}
              isInvalid={touched.last_name && !!errors.last_name}
              aria-required
            />
            <ErrorMessage name="last_name">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>
        </Col>
      </Row>

      <Form.Group
        className="mb-lg-3 mb-1"
        controlId="phone"
      >
        <FormLabel required>Phone Number</FormLabel>
        <Field
          name="phone"
          type="tel"
          as={Form.Control}
          isInvalid={touched.phone && !!errors.phone}
          aria-required
        />
        <ErrorMessage name="phone">
          {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
        </ErrorMessage>
      </Form.Group>

      <Form.Group
        className="mb-lg-3 mb-1"
        controlId="email"
      >
        <FormLabel required>Email Address</FormLabel>
        <Field
          name="email"
          type="email"
          as={Form.Control}
          isInvalid={touched.email && !!errors.email}
          aria-required
        />
        <ErrorMessage name="email">
          {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
        </ErrorMessage>
      </Form.Group>
    </>
  );
};
